module.exports = __webpack_public_path__ + "img/modifications--without_support.45cb4dab.png";